module.exports = __webpack_public_path__ + "static/media/Impulse_buyer.e4342052.svg";